var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "supply-form",
          attrs: { model: _vm.form, "label-width": "200px" }
        },
        [
          _c("div", { staticClass: "supply-module" }, [
            _c("div", { staticClass: "module-title" }, [_vm._v("商家标签")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "module-content" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "是否KA", prop: "is_ka" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否KA" },
                        model: {
                          value: _vm.form.is_ka,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_ka", $$v)
                          },
                          expression: "form.is_ka"
                        }
                      },
                      _vm._l(_vm.public_option, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否实力档口", prop: "is_strength" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否实力档口" },
                        model: {
                          value: _vm.form.is_strength,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_strength", $$v)
                          },
                          expression: "form.is_strength"
                        }
                      },
                      _vm._l(_vm.public_option, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否轻入驻", prop: "is_lower_enter" } },
                  [
                    _c(
                      "div",
                      { staticClass: "lower-enter-wrap" },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "是否轻入驻" },
                            model: {
                              value: _vm.form.is_lower_enter,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "is_lower_enter", $$v)
                              },
                              expression: "form.is_lower_enter"
                            }
                          },
                          _vm._l(_vm.public_option, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _vm.form.is_lower_enter == 1
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "月目标",
                                  prop: "m_goal",
                                  "label-width": "100px"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: { type: "number" },
                                  model: {
                                    value: _vm.form.m_goal,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "m_goal", $$v)
                                    },
                                    expression: "form.m_goal"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "履约率标杆商家", prop: "is_benchmarking" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          disabled: _vm.form.is_benchmarking == "0",
                          placeholder: "履约率标杆商家"
                        },
                        on: { change: _vm.setBenchmarking },
                        model: {
                          value: _vm.form.is_benchmarking,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_benchmarking", $$v)
                          },
                          expression: "form.is_benchmarking"
                        }
                      },
                      _vm._l(_vm.public_option, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "在售款数上限层级",
                      prop: "sale_number_level_txt"
                    }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.sale_number_level_txt,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "sale_number_level_txt", $$v)
                        },
                        expression: "form.sale_number_level_txt"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "主营品类", prop: "main_category_txt" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.main_category_txt,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "main_category_txt", $$v)
                        },
                        expression: "form.main_category_txt"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "supply-module" }, [
            _c("div", { staticClass: "module-title" }, [_vm._v("上款效率")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "module-content" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "是否全款全上", prop: "is_strength" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否全款全上" },
                        model: {
                          value: _vm.form.is_full,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_full", $$v)
                          },
                          expression: "form.is_full"
                        }
                      },
                      _vm._l(_vm.public_option, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否自主上款", prop: "is_self" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          disabled: _vm.form.open_deposit == "1",
                          placeholder: "是否自主上款"
                        },
                        model: {
                          value: _vm.form.is_self,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_self", $$v)
                          },
                          expression: "form.is_self"
                        }
                      },
                      _vm._l(_vm.public_option, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "是否开启截图上款",
                      prop: "is_screenshot_for_add_goods"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否开启截图上款" },
                        model: {
                          value: _vm.form.is_screenshot_for_add_goods,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "is_screenshot_for_add_goods",
                              $$v
                            )
                          },
                          expression: "form.is_screenshot_for_add_goods"
                        }
                      },
                      _vm._l(_vm.public_option, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "商品发布/编辑免审",
                      prop: "goods_exempt_examine"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "商品发布免审", disabled: true },
                        on: { change: _vm.setSelfNeedAudit },
                        model: {
                          value: _vm.form.goods_exempt_examine,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "goods_exempt_examine", $$v)
                          },
                          expression: "form.goods_exempt_examine"
                        }
                      },
                      [
                        _c(
                          "el-option",
                          { attrs: { label: "否", value: "0" } },
                          [_vm._v(" 否 ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-option",
                          { attrs: { label: "是", value: "1" } },
                          [_vm._v(" 是 ")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.form.goods_exempt_examine === "1"
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.handleExitAbsolveReview()
                              }
                            }
                          },
                          [_vm._v("\n            退出免审\n          ")]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "周上新数限制", prop: "week_new_limit" } },
                  [
                    _c("el-input", {
                      staticStyle: { "max-width": "193px" },
                      attrs: { placeholder: "" },
                      model: {
                        value: _vm.form.week_new_limit,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "week_new_limit", $$v)
                        },
                        expression: "form.week_new_limit"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v("若设置为空即不限制")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "月上新数限制", prop: "month_new_limit" } },
                  [
                    _c("el-input", {
                      staticStyle: { "max-width": "193px" },
                      attrs: { placeholder: "" },
                      model: {
                        value: _vm.form.month_new_limit,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "month_new_limit", $$v)
                        },
                        expression: "form.month_new_limit"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v("若设置为空即不限制")
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "supply-module" }, [
            _c("div", { staticClass: "module-title" }, [_vm._v("销售权限")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "module-content" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "能否参与特价销售", prop: "special_sale" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "参与特价销售" },
                        model: {
                          value: _vm.form.special_sale,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "special_sale", $$v)
                          },
                          expression: "form.special_sale"
                        }
                      },
                      _vm._l(_vm.public_option, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-option-tips" }, [
                      _vm._v(
                        '\n            是否能以"特价"标签上架至一手专场上销售\n          '
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "是否特价治理",
                      prop: "is_special_treatment"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否特价治理" },
                        model: {
                          value: _vm.form.is_special_treatment,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_special_treatment", $$v)
                          },
                          expression: "form.is_special_treatment"
                        }
                      },
                      _vm._l(_vm.offsiteOptions, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "8px" },
                        attrs: { type: "text" },
                        on: { click: _vm.handleViewSpecialRule }
                      },
                      [_vm._v("\n            查看特价治理规则\n          ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "是否自运营专场",
                      prop: "self_operation_special"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        model: {
                          value: _vm.form.self_operation_special,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "self_operation_special", $$v)
                          },
                          expression: "form.self_operation_special"
                        }
                      },
                      _vm._l(_vm.public_option, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-option-tips" }, [
                      _vm._v(
                        "决定商家是否可以管理自己的专场信息（上下架专场商品，上传专场半屏购图）"
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否开启直播", prop: "is_live" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否开启直播" },
                        model: {
                          value: _vm.form.is_live,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_live", $$v)
                          },
                          expression: "form.is_live"
                        }
                      },
                      _vm._l(_vm.public_option, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.form.is_live == 1
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "直播频率", prop: "live_type" } },
                      [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "1" },
                            model: {
                              value: _vm.form.live_type,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "live_type", $$v)
                              },
                              expression: "form.live_type"
                            }
                          },
                          [_vm._v(" 按次申请 ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "2" },
                            model: {
                              value: _vm.form.live_type,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "live_type", $$v)
                              },
                              expression: "form.live_type"
                            }
                          },
                          [_vm._v("\n            不限直播次数\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "3" },
                            model: {
                              value: _vm.form.live_type,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "live_type", $$v)
                              },
                              expression: "form.live_type"
                            }
                          },
                          [
                            _vm._v(
                              "\n            每周可自主直播\n            "
                            ),
                            _vm.form.live_type == 3
                              ? _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    type: "text",
                                    value: _vm.form.live_num
                                  },
                                  model: {
                                    value: _vm.form.live_num,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "live_num", $$v)
                                    },
                                    expression: "form.live_num"
                                  }
                                })
                              : _vm._e(),
                            _vm._v("\n            次\n          ")
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "4" },
                            model: {
                              value: _vm.form.live_type,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "live_type", $$v)
                              },
                              expression: "form.live_type"
                            }
                          },
                          [
                            _vm._v(
                              "\n            每月可自主直播\n            "
                            ),
                            _vm.form.live_type == 4
                              ? _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    type: "text",
                                    value: _vm.form.live_num
                                  },
                                  model: {
                                    value: _vm.form.live_num,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "live_num", $$v)
                                    },
                                    expression: "form.live_num"
                                  }
                                })
                              : _vm._e(),
                            _vm._v("\n            次\n          ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "是否邀请商家自主申请入驻",
                      prop: "open_deposit"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否邀请商家自主申请入驻" },
                        on: { change: _vm.setOpenDeposit },
                        model: {
                          value: _vm.form.open_deposit,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "open_deposit", $$v)
                          },
                          expression: "form.open_deposit"
                        }
                      },
                      _vm._l(_vm.public_option, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "supply-module" }, [
            _c("div", { staticClass: "module-title" }, [_vm._v("履约工具")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "module-content" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "前置仓商品是否可以超点入库",
                      prop: "supply_excess_point_goods"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否可以超点入库" },
                        model: {
                          value: _vm.form.supply_excess_point_goods,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "supply_excess_point_goods", $$v)
                          },
                          expression: "form.supply_excess_point_goods"
                        }
                      },
                      _vm._l(_vm.public_option2, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-option-tips" }, [
                      _vm._v(
                        "\n            关闭后，该商家的前置仓商品只能根据已有的前置仓计划入库，不能超点入库\n          "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "前置仓商家自荐",
                      prop: "pre_plan_supply_auto_create"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "前置仓商家自荐" },
                        model: {
                          value: _vm.form.pre_plan_supply_auto_create,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "pre_plan_supply_auto_create",
                              $$v
                            )
                          },
                          expression: "form.pre_plan_supply_auto_create"
                        }
                      },
                      _vm._l(
                        [
                          { label: "是", value: "1" },
                          { label: "否", value: "2" }
                        ],
                        function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        }
                      ),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-option-tips" }, [
                      _vm._v(
                        '\n            开启/关闭，决定了商家的爆版APP/PC是否能看到「备货建议数据」，及"前置仓计划开单"（ERP后台不受影响）。\n          '
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "前置仓入库时消除待开单数据",
                      prop: "is_auto_cancel_plan"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "前置仓入库时消除待开单数据" },
                        model: {
                          value: _vm.form.is_auto_cancel_plan,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_auto_cancel_plan", $$v)
                          },
                          expression: "form.is_auto_cancel_plan"
                        }
                      },
                      _vm._l(
                        [
                          { label: "否", value: "1" },
                          { label: "是", value: "2" }
                        ],
                        function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        }
                      ),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-option-tips" }, [
                      _vm._v(
                        "\n            开启后，若前置仓入库时，采购计划中该sku待开单数将相应减少。\n          "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "退换货是否需接收", prop: "reject_accept" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "退换货是否需接收" },
                        model: {
                          value: _vm.form.reject_accept,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "reject_accept", $$v)
                          },
                          expression: "form.reject_accept"
                        }
                      },
                      _vm._l(_vm.public_option, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-option-tips" }, [
                      _vm._v(
                        "\n            是—>退换货出库后需要完成次品接收才会生成退换货欠货。否—>退换货出库后直接生成退换货欠货。\n          "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "售后提前代采计划", prop: "as_plan" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "售后提前代采计划" },
                        model: {
                          value: _vm.form.as_plan,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "as_plan", $$v)
                          },
                          expression: "form.as_plan"
                        }
                      },
                      _vm._l(_vm.public_option, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-option-tips" }, [
                      _vm._v(
                        '\n            开启后，当商家有换货类型售后工单商品产品且被填上了快递单号，则次日自动生成"售后"代采计划\n          '
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "转抵扣并重新代采",
                      prop: "is_deduct_repurchase"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "转抵扣并重新代采" },
                        model: {
                          value: _vm.form.is_deduct_repurchase,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_deduct_repurchase", $$v)
                          },
                          expression: "form.is_deduct_repurchase"
                        }
                      },
                      _vm._l(_vm.public_option, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-option-tips" }, [
                      _vm._v(
                        '\n            关闭后，在代采APP不能对该商家的欠货进行"转抵扣并重新代采"、"预抵扣并重新代采"的操作\n          '
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "重新代采计划全量生成",
                      prop: "all_rebuild_plan"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "重新代采计划全量生成" },
                        model: {
                          value: _vm.form.all_rebuild_plan,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "all_rebuild_plan", $$v)
                          },
                          expression: "form.all_rebuild_plan"
                        }
                      },
                      _vm._l(_vm.public_option, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-option-tips" }, [
                      _vm._v(
                        '\n            开启后，无论是否有客需，都会根据"重采操作"在次日等量生成"重新代采计划"。\n          '
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "超时断重采计划",
                      prop: "reload_plan_time_out_days"
                    }
                  },
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "120px" },
                      attrs: {
                        min: 1,
                        max: 999,
                        precision: 0,
                        controls: false
                      },
                      model: {
                        value: _vm.form.reload_plan_time_out_days,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "reload_plan_time_out_days", $$v)
                        },
                        expression: "form.reload_plan_time_out_days"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "margin-left": "5px" } }, [
                      _vm._v("天，")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-option-tips" }, [
                      _vm._v(
                        "\n            超过（大于）设定天数未开单的重采计划（全量重采-不判断客需）自动断待开单。\n          "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "开单方式",
                      prop: "billing_type",
                      rules: _vm.rules.ruleChange
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "开单方式" },
                        model: {
                          value: _vm.form.billing_type,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "billing_type", $$v)
                          },
                          expression: "form.billing_type"
                        }
                      },
                      _vm._l(_vm.billingTypeOptions, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-option-tips" }, [
                      _vm._v(
                        '\n            实数单：商家使用爆版开单后自动发货，同时生成「代采订单」和"在途库存"。\n            排单单：爆版开单不生成"在途库存"。\n          '
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "发货方式",
                      prop: "is_offsite",
                      rules: _vm.rules.ruleChange
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "发货方式" },
                        model: {
                          value: _vm.form.is_offsite,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_offsite", $$v)
                          },
                          expression: "form.is_offsite"
                        }
                      },
                      _vm._l(_vm.deliveryType, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-option-tips" }, [
                      _vm._v(
                        "\n            商家自送：自送至一手驻点或仓库；\n            快递：爆版发货时必须录入快递单号；\n            商家自送/快递：发货时由商家选择。\n          "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "是否启用呆账",
                      prop: "stagnant_status",
                      rules: _vm.rules.ruleChange
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否启用呆账" },
                        model: {
                          value: _vm.form.stagnant_status,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "stagnant_status", $$v)
                          },
                          expression: "form.stagnant_status"
                        }
                      },
                      _vm._l(_vm.offsiteOptions, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-option-tips" }, [
                      _vm._v(
                        "\n            是→采购APP展示欠货转呆账的操作入口并支持转为呆账；\n            否→不展示且不支持转为呆账。\n          "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "是否自动用抵扣商品",
                      prop: "is_auto_ded",
                      rules: _vm.rules.ruleChange
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "自动抵扣商品" },
                        model: {
                          value: _vm.form.is_auto_ded,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_auto_ded", $$v)
                          },
                          expression: "form.is_auto_ded"
                        }
                      },
                      _vm._l(_vm.offsiteOptions, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-option-tips" }, [
                      _vm._v(
                        '\n            "是"：开单时由系统自动选择抵扣商品。\n            "否"：开单时由人工选择抵扣商品。\n          '
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "超期欠货自动转待抵扣",
                      prop: "whether_to_deduct",
                      rules: _vm.rules.ruleChange
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "超期欠货自动转待抵扣" },
                        model: {
                          value: _vm.form.whether_to_deduct,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "whether_to_deduct", $$v)
                          },
                          expression: "form.whether_to_deduct"
                        }
                      },
                      _vm._l(_vm.offsiteOptions, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "select-option-tips" }, [
                      _vm._v(
                        "\n            是→订单欠货超期30天自动转入待抵扣（限已支付的订单欠货）；\n            否→不自动转待抵扣。\n          "
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "supply-module" }, [
            _c(
              "div",
              { staticClass: "module-title" },
              [
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-bottom": "0" },
                    attrs: { label: "无理由退货", "label-width": "100px" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        model: {
                          value: _vm.form.no_reason_return,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "no_reason_return", $$v)
                          },
                          expression: "form.no_reason_return"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "开启", value: "1" }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "关闭", value: "0" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "module-content" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "退货服务生效日期" } },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        "value-format": "yyyy-MM-dd",
                        disabled: _vm.closeNr,
                        "picker-options": _vm.constantMap.pickerOptions
                      },
                      model: {
                        value: _vm.form.no_reason_begin_time,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "no_reason_begin_time", $$v)
                        },
                        expression: "form.no_reason_begin_time"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.form.no_reason_return === "1" &&
                              _vm.form.no_reason_begin_time,
                            expression:
                              "\n              form.no_reason_return === '1' && form.no_reason_begin_time\n            "
                          }
                        ],
                        staticStyle: { display: "inline", color: "#888" }
                      },
                      [
                        _vm._v("\n            一手APP从"),
                        _c("span", { staticStyle: { color: "blue" } }, [
                          _vm._v(_vm._s(_vm.noReasonTimeMark[0]))
                        ]),
                        _vm._v(
                          '的专场开始，商品显示"退货服务"标签。代采开单将对计划生成时间从'
                        ),
                        _c("span", { staticStyle: { color: "blue" } }, [
                          _vm._v(_vm._s(_vm.noReasonTimeMark[1]))
                        ]),
                        _vm._v(
                          "开始，进行平台佣金及退货服务费的代采订单扣费。\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "退货限制比例设置" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "190px" },
                      attrs: { placeholder: "请输入内容" },
                      on: { change: _vm.validateData },
                      model: {
                        value: _vm.form.return_limit_ratio,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "return_limit_ratio", $$v)
                        },
                        expression: "form.return_limit_ratio"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticStyle: { margin: "10px" } }, [
                      _vm._v("%")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "退货模式" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { disabled: _vm.form.refund_model == "2" },
                        on: { change: _vm.changRefundModel },
                        model: {
                          value: _vm.form.refund_model,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "refund_model", $$v)
                          },
                          expression: "form.refund_model"
                        }
                      },
                      _vm._l(_vm.refund_models, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.refundModelsComputed,
                            expression: "refundModelsComputed"
                          }
                        ],
                        staticStyle: { display: "inline", color: "red" }
                      },
                      [
                        _vm._v(
                          '\n            "由商家承担"下，退货服务比例设置失效。代采开单不会扣除退货服务费。\n          '
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "退货服务比例(%)" } },
                  [
                    _c("el-inputNumber", {
                      staticStyle: { width: "220px" },
                      attrs: {
                        min: 0.0,
                        max: 100.0,
                        precision: 2,
                        disabled: _vm.closeNr || _vm.refundModelsComputed
                      },
                      model: {
                        value: _vm.form.refund_service_fee_rate,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "refund_service_fee_rate", $$v)
                        },
                        expression: "form.refund_service_fee_rate"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "supply-module" }, [
            _c("div", { staticClass: "module-title" }, [_vm._v("第三方打通")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "module-content" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "向第三方推送采购计划",
                      prop: "is_push_wcg_plan"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否推送" },
                        model: {
                          value: _vm.form.is_push_wcg_plan,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_push_wcg_plan", $$v)
                          },
                          expression: "form.is_push_wcg_plan"
                        }
                      },
                      _vm._l(_vm.constantMap.optionsSwitch, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "【开启】一手采购计划给已打通的商陆花/聚水潭的自动推送生成订货单。【关闭】不推送"
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "接收第三方实时库存",
                      prop: "is_sync_supply_stock"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否接收" },
                        model: {
                          value: _vm.form.is_sync_supply_stock,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_sync_supply_stock", $$v)
                          },
                          expression: "form.is_sync_supply_stock"
                        }
                      },
                      _vm._l(_vm.constantMap.optionsSwitch, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "【开启】已打通的商陆花/聚水潭商品库存发生变化后同步至一手商品库。【关闭】不同步"
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否自动开单", prop: "is_auto_billing" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否自动开单" },
                        model: {
                          value: _vm.form.is_auto_billing,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_auto_billing", $$v)
                          },
                          expression: "form.is_auto_billing"
                        }
                      },
                      _vm._l(_vm.is_auto_billing_option, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "打通聚水潭/商陆花的商家支持该功能，【否】：不开启功能，【排单单】：当天自动开排单单，【实数单】：当天按发货的商品数量开实数单；"
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "第三方发货生成采购单方式", prop: "" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择" },
                        model: {
                          value: _vm.form.create_order_way,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "create_order_way", $$v)
                          },
                          expression: "form.create_order_way"
                        }
                      },
                      _vm._l(_vm.create_order_way, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "margin-left": "10px",
                          display: "inline-flex",
                          "flex-direction": "column"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "\n              采购订单=发货批次：一手采购单根据商陆花/聚水潭发货批次生成相应的商品数据；\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "\n              采购订单=销售订货单：根据商陆花/聚水潭发货波次当中的订货单号生成多个一手采购订单；\n            "
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "supply-module" }, [
            _c(
              "div",
              { staticClass: "module-title" },
              [
                _vm._v("\n        慢必赔：\n        "),
                _c("el-switch", {
                  attrs: {
                    "active-value": "1",
                    "inactive-value": "2",
                    "active-text": "已开启",
                    "inactive-text": "已关闭"
                  },
                  on: {
                    change: function($event) {
                      return _vm.handleSwitchChange($event, false)
                    }
                  },
                  model: {
                    value: _vm.form.is_slow_compensation,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "is_slow_compensation", $$v)
                    },
                    expression: "form.is_slow_compensation"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.form.is_slow_compensation === "1"
              ? _c(
                  "div",
                  { staticClass: "module-content" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "生效日期",
                          prop: "slow_compensation_effective_date",
                          "label-width": "100px",
                          rules: [
                            {
                              required: _vm.form.is_slow_compensation === "1",
                              message: "请选择生效日期",
                              trigger: "change"
                            }
                          ]
                        }
                      },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "date",
                            placeholder: "选择日期",
                            "value-format": "yyyy-MM-dd",
                            clearable: false,
                            "picker-options": {
                              disabledDate: function(date) {
                                return date.getTime() < Date.now()
                              }
                            }
                          },
                          model: {
                            value: _vm.form.slow_compensation_effective_date,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.form,
                                "slow_compensation_effective_date",
                                $$v
                              )
                            },
                            expression: "form.slow_compensation_effective_date"
                          }
                        }),
                        _vm._v("\n\n          一手APP从"),
                        _c("span", { staticStyle: { color: "blue" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.getFormattedDate(
                                _vm.form.slow_compensation_effective_date
                              )
                            ) + "\n            7:00"
                          )
                        ]),
                        _vm._v('的专场开始，商品显示"慢必赔"服务标签。'),
                        _c("span", { staticStyle: { color: "blue" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.getNextDayDate(
                                _vm.form.slow_compensation_effective_date
                              )
                            ) + "\n            7:00"
                          )
                        ]),
                        _vm._v(
                          "生成的代采计划商品将被标记货期信息，并开始考核货期履约情况。\n        "
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { "margin-top": "30px", "margin-left": "160px" },
              attrs: { type: "primary" },
              on: { click: _vm.submit }
            },
            [_vm._v("提交")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "60%",
            "before-close": _vm.handleDialogClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              staticStyle: { "text-align": "center" },
              attrs: { slot: "title" },
              slot: "title"
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.dialogTitle) +
                  _vm._s(_vm.form.slow_compensation_effective_date) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _vm.dialogTitle !== "关闭慢必赔项目"
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    "label-width": "120px",
                    label: "生效日期",
                    prop: "slow_compensation_effective_date"
                  }
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      placeholder: "选择日期",
                      "value-format": "yyyy-MM-dd",
                      clearable: false,
                      "picker-options": {
                        disabledDate: function(date) {
                          return date.getTime() < Date.now()
                        }
                      }
                    },
                    on: { change: _vm.updateDialogMessage },
                    model: {
                      value: _vm.form.slow_compensation_effective_date,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.form,
                          "slow_compensation_effective_date",
                          $$v
                        )
                      },
                      expression: "form.slow_compensation_effective_date"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-form-item", { attrs: { "label-width": "50px" } }, [
            _c("div", {
              staticStyle: { "line-height": "24px", "margin-bottom": "20px" },
              domProps: { innerHTML: _vm._s(_vm.dialogMessage) }
            })
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleDialogCancel } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleDialogConfirm }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-299e5ea8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-299e5ea8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/supply/updateSupplyComponents/LimitOfSupply.vue
// module id = null
// module chunks = 